import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  Translation,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  translocoConfig,
  TranslocoModule,
  TranslocoService,
} from '@ngneat/transloco';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      // Provide the default Transloco configuration
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: [
          {
            id: 'pt',
            label: 'Português',
          },
          {
            id: 'en',
            label: 'English',
          },
        ],
        defaultLang: 'pt',
        fallbackLang: 'pt',
        reRenderOnLangChange: true,
        prodMode: true,
      }),
    },
    {
      // Provide the default Transloco loader
      provide: TRANSLOCO_LOADER,
      useClass: TranslocoHttpLoader,
    },
    {
      // Preload the default language before the app starts to prevent empty/jumping content
      provide: APP_INITIALIZER,
      deps: [TranslocoService, ActivatedRoute],
      useFactory:
        (
          translocoService: TranslocoService,
          activedRoute: ActivatedRoute,
        ): any =>
        (): Promise<Translation> => {
          const defaultLang = translocoService.getDefaultLang();
          const lang = activedRoute.snapshot?.queryParams?.lang;
          const activeLang = lang || defaultLang;
          translocoService.setActiveLang(activeLang);
          return translocoService.load(activeLang).toPromise();
        },
      multi: true,
    },
  ],
})
export class TranslocoCoreModule {}
